import { authorizedGet } from "@onsite_app/MobileOrderingMenu/authorizedRequests";
import camelcaseKeys from "camelcase-keys";

import { VoucherTemplatesSchema } from "./schema";

export const fetchVoucherTemplates = async () => {
  const { body } = await authorizedGet({
    url: `/v1/voucher_templates`,
  });
  return VoucherTemplatesSchema.parse(
    camelcaseKeys(body.voucher_templates, { deep: true }),
  );
};
